module.exports = __webpack_public_path__ + "@/assets/img/fintoclogo.b1586bc0.png";